import { render } from "./NewPassword.vue?vue&type=template&id=154f103c&scoped=true&ts=true"
import script from "./NewPassword.vue?vue&type=script&lang=ts"
export * from "./NewPassword.vue?vue&type=script&lang=ts"

import "./NewPassword.vue?vue&type=style&index=0&id=154f103c&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-154f103c"]])

export default __exports__